
import { ViewCell, Cell, DefaultEditor, Editor } from 'ng2-smart-table';
import { Component, OnInit } from '@angular/core';



/**
 * @ignore
 */
@Component({
  template: `
  <input *ngIf="fieldEnabled" type="text" (change)="change($event)" nbInput fullWidth id="valorCampo" name="valorCampo" [(ngModel)]="currentValue"/>
  `,
})
export class ExtraPropertyFieldEditorComponent extends DefaultEditor implements OnInit {

  availableFields: any = {
//    'min': ['date','date_range','datetime','datetime_range','hour'],
//    'max': ['date','date_range','datetime','datetime_range','hour'],
    'criteria': ['number','date','date_range','datetime','datetime_range','hour','hours'],
    'auto': ['location'],
    'elements': ['select','radio'],
  }
   currentValue: any;
   fieldEnabled = false;
  constructor() {
    super();

    }

  ngOnInit() {
    console.log(this.cell);
    console.log((this.cell.getRow().getData() as any).type);

    this.updateEnabled();

    this.currentValue = this.cell.getValue();
  }

  public change(event) {

    this.cell.newValue = this.currentValue;

  }

  public updateEnabled() {
    this.fieldEnabled = this.availableFields[this.cell.getColumn().id].indexOf((this.cell.getRow().getData() as any).type) !== -1;
  }

  // Wrong not working example:
  // this function will not reset back to the initial value after cancel
  wrongValueChange() {

  }

  // Correct working example:
  // this will reset back to the initial value after cancel
  rightValueChange() {

  }


}
